<template>
  <span class="d-none d-lg-block d-xl-block mb-2">
    Selezione del posto per
    <span class="text-primary semibold">{{ passengerName }}</span><span
      v-if="isHoldingInfant"
      class="thin"
    > + neonato</span><vb-icon
      v-if="seat_hint"
      name="info"
      :size="12"
      color="AAA"
      class="ml-1 d-inline-block align-middle"
      v-b-popover.hover.top="seat_hint"
    />
  </span>
</template>

<script>
import { formatPassengerName } from '@liveflight/utilities/mixins'
import { passenger_seat_hint } from '@liveflight/utilities/seat-map'

export default {
  name: 'PassengerContextDisplay',
  props: {
    passenger: Object,
    isHoldingInfant: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    passengerName() {
      return formatPassengerName(this.passenger)
    },
    seat_hint() {
      return passenger_seat_hint(this.passenger)
    },
  },
}
</script>
